
import { defineComponent } from "vue";
import SearchApplianceIconItem from "./SearchApplianceIconItem.vue";
export default defineComponent({
  name: "SearchApplianceIconList",
  components: { SearchApplianceIconItem },
  props: {
    /**
     * AppliacneCategoryタグを表示するデータの配列
     */
    appliances: {
      type: Array,
      default: () => []
    }
  }
});
